import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { I18nProvider } from "@/lib/i18n";
import { AuthProvider, Protected, useAuth, homeFor, Spinner } from "@/lib/auth";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import HowItWorks from "@/pages/HowItWorks";
import JoinPro from "@/pages/JoinPro";
import RequestService from "@/pages/RequestService";
import { Login, Register } from "@/pages/Auth";
import CustomerDashboard from "@/pages/CustomerDashboard";
import RequestDetail from "@/pages/RequestDetail";
import ContractorDashboard from "@/pages/ContractorDashboard";
import OwnerDashboard from "@/pages/OwnerDashboard";
import { InstallPrompt } from "@/components/InstallPrompt";
import BookCleaning from "@/pages/BookCleaning";
import BuildHome from "@/pages/BuildHome";
import DesignHome from "@/pages/DesignHome";

function DashboardSwitch() {
  const { user } = useAuth();
  if (user === null) return <Spinner />;
  if (user && user.role !== "customer") return <Navigate to={homeFor(user.role)} replace />;
  return <Protected roles={["customer"]}><CustomerDashboard /></Protected>;
}

const detail = <Protected><RequestDetail /></Protected>;

function App() {
  return (
    <I18nProvider>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/services" element={<Services />} />
              <Route path="/how-it-works" element={<HowItWorks />} />
              <Route path="/join" element={<JoinPro />} />
              <Route path="/request" element={<RequestService />} />
              <Route path="/cleaning" element={<BookCleaning />} />
              <Route path="/build" element={<BuildHome />} />
              <Route path="/build/design" element={<DesignHome />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/dashboard" element={<DashboardSwitch />} />
              <Route path="/dashboard/requests/:id" element={detail} />
              <Route path="/contractor" element={<Protected roles={["contractor"]}><ContractorDashboard /></Protected>} />
              <Route path="/contractor/jobs/:id" element={detail} />
              <Route path="/owner" element={<Protected roles={["owner"]}><OwnerDashboard /></Protected>} />
              <Route path="/owner/requests/:id" element={detail} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Route>
          </Routes>
        </BrowserRouter>
        <InstallPrompt />
        <Toaster richColors position="top-center" />
      </AuthProvider>
    </I18nProvider>
  );
}

export default App;
